import React, { Component } from 'react'
import PopupWindow from './PopupWindow'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import LatestScoresWindow from './LatestScoresWindow'
import PlayersStatsWindow from './PlayersStatsWindow'
import GameStatsWindow from './GameStatsWindow'
import TeamFormationWindow from './TeamFormationWindow'
import SummaryWindow from './SummaryWindow'
import * as StatisticActions from '../../actions/statisticActions';
import Checkbox from './Checkbox'
import SettingsWindow from './SettingsWindow'
import ChatWindow from './ChatWindow'
import AboutWindow from './AboutWindow'
import DonateWindow from './DonateWindow'
import TextWindow from './TextWindow'
import PitchWindow from './PitchWindow'

class StatsWindowContainer extends Component {

    constructor(props) {
        super(props);

        this.StatsButtonPosition = {top: 100, left: 350};
    }

    
    componentDidMount() {
      this.calculateStatsSelectorPosition();

      window.addEventListener("resize", ()=> {
        this.calculateStatsSelectorPosition();
        this.forceUpdate();
      });
    }

    calculateStatsSelectorPosition(){
      var button = document.getElementById("statsButton");
      var pos = getCoords(button);
      this.StatsButtonPosition = {top: pos.top+35, left: pos.left - 200};
    }
    
    onStatsControlButtonClick(){
      if(this.props.statisticWindows.statsSelectorVisible)
        this.props.StatisticActions.close_stats_selector();
      else
        this.props.StatisticActions.show_stats_selector();
    }

    render() {
        var latestScoresVisible = this.props.statisticWindows.latestScores.visible;
        var summaryVisible = this.props.statisticWindows.summary.visible;
        var homePlayersStatsVisible = this.props.statisticWindows.homePlayersStats.visible;
        var awayPlayersStatsVisible = this.props.statisticWindows.awayPlayersStats.visible;
        var homeFormationVisible = this.props.statisticWindows.homeFormation.visible;
        var awayFormationVisible = this.props.statisticWindows.awayFormation.visible;
        var gameStatsVisible = this.props.statisticWindows.gameStats.visible;
        var chatVisible = this.props.statisticWindows.chat.visible;
        var showAbout = this.props.showAbout;
        var showDonate = this.props.showDonate;
        var textVisible = this.props.statisticWindows.text.visible;
        var pitchVisible = this.props.statisticWindows.pitch.visible;

        const { show_stats_window, close_stats_window, close_stats_selector} = this.props.StatisticActions;

        //<Checkbox label={'Чат'} checked={chatVisible} onChecked={()=>show_stats_window('chat')} onUnChecked={()=>close_stats_window('chat')}/>
        return (<div>
                    {
                        this.props.statisticWindows.statsSelectorVisible ?
                        <PopupWindow header="Окна Статистики" draggable={false} show_header={false} top={this.StatsButtonPosition.top} left={this.StatsButtonPosition.left} onClose={close_stats_selector} width={350} zIndex={7}>
                            <Checkbox label="Обзор матча" checked={summaryVisible} onChecked={()=>show_stats_window('summary')} onUnChecked={()=>close_stats_window('summary')}/>
                            <Checkbox label="Последние результаты" checked={latestScoresVisible} onChecked={()=>show_stats_window('latestScores')} onUnChecked={()=>close_stats_window('latestScores')}/>
                            <Checkbox label={this.props.homeTeamName + ': Игроки'} checked={homePlayersStatsVisible} onChecked={()=>show_stats_window('homePlayersStats')} onUnChecked={()=>close_stats_window('homePlayersStats')}/>
                            <Checkbox label={this.props.awayTeamName + ': Игроки'} checked={awayPlayersStatsVisible} onChecked={()=>show_stats_window('awayPlayersStats')} onUnChecked={()=>close_stats_window('awayPlayersStats')}/>
                            <Checkbox label={this.props.homeTeamName + ': Расстановка'} checked={homeFormationVisible} onChecked={()=>show_stats_window('homeFormation')} onUnChecked={()=>close_stats_window('homeFormation')}/>
                            <Checkbox label={this.props.awayTeamName + ': Расстановка'} checked={awayFormationVisible} onChecked={()=>show_stats_window('awayFormation')} onUnChecked={()=>close_stats_window('awayFormation')}/>
                            <Checkbox label={'Статистика Матча'} checked={gameStatsVisible} onChecked={()=>show_stats_window('gameStats')} onUnChecked={()=>close_stats_window('gameStats')}/>
                            <Checkbox label={'Текстовый отчет'} checked={textVisible} onChecked={()=>show_stats_window('text')} onUnChecked={()=>close_stats_window('text')}/>
                            <Checkbox label={'Поле'} checked={pitchVisible} onChecked={()=>show_stats_window('pitch')} onUnChecked={()=>close_stats_window('pitch')}/>
                        </PopupWindow>
                        :
                        null
                    }
                    {summaryVisible == true ? <SummaryWindow id={'summary'}/> : null}
                    {latestScoresVisible == true ? <LatestScoresWindow id={'latestScores'}/> : null}
                    {homePlayersStatsVisible == true ? <PlayersStatsWindow id={'homePlayersStats'} home={true}/> : null}
                    {awayPlayersStatsVisible == true ? <PlayersStatsWindow id={'awayPlayersStats'} home={false} /> : null}
                    {homeFormationVisible == true ? <TeamFormationWindow id={'homeFormation'} home={true}/> : null}
                    {awayFormationVisible == true ? <TeamFormationWindow id={'awayFormation'} home={false} /> : null}
                    {gameStatsVisible == true ? <GameStatsWindow id={'gameStats'} /> : null}
                    {chatVisible == true ? <ChatWindow id={'chat'} /> : null}
                    {showAbout == true ? <AboutWindow /> : null}
                    {showDonate == true ? <DonateWindow /> : null}
                    {textVisible == true ? <TextWindow id={'text'} /> : null}
                    {pitchVisible == true ? <PitchWindow id={'pitch'} /> : null}
                    <SettingsWindow/>
                </div>)
    }
}

function mapStateToProps(state, ownProps) {
    return {
        statisticWindows: state.statisticWindows,
        homeTeamName: state.HomeTeam.Name,
        awayTeamName: state.AwayTeam.Name,
        showSettings: state.showSettings,
        showAbout: state.showAbout,
        showDonate: state.showDonate
    };
}

function mapDispatchToProps(dispatch) {
    return {
        StatisticActions: bindActionCreators(StatisticActions, dispatch)
    }
}

function getCoords(elem) { // crossbrowser version
    var box = elem.getBoundingClientRect();

    var body = document.body;
    var docEl = document.documentElement;

    var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

    var clientTop = docEl.clientTop || body.clientTop || 0;
    var clientLeft = docEl.clientLeft || body.clientLeft || 0;

    var top  = box.top +  scrollTop - clientTop;
    var left = box.left + scrollLeft - clientLeft;

    return { top: Math.round(top), left: Math.round(left) };
}


export default connect(mapStateToProps, mapDispatchToProps)(StatsWindowContainer)



/** WEBPACK FOOTER **
 ** ./src/components/PopupStats/StatsWindowContainer.js
 **/